export default __webpack_public_path__ + "static/media/rect-article.fa731d5d.svg";